import styled from 'styled-components';

export const ContentStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.grey[200]};
  flex-grow: 1;
  height: 100%;
  overflow: hidden;
  position: relative;
`;
